import { render } from "./ExamResult.vue?vue&type=template&id=51193e2f&scoped=true"
import script from "./ExamResult.vue?vue&type=script&lang=js"
export * from "./ExamResult.vue?vue&type=script&lang=js"

import "./ExamResult.vue?vue&type=style&index=0&id=51193e2f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51193e2f"]])

export default __exports__